import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { returnNavigationObject } from "../../../utils";
import TextBox from "../TextBox";
import Button from "../Button";
import Home from "../../../assets/home.svg";
import HomeSelected from "../../../assets/home_selected.svg";
import MyBookings from "../../../assets/my_booking.svg";
import MyBookingsSelected from "../../../assets/my_booking_selected.svg";
import Account from "../../../assets/account.svg";
import {
  MY_BOOKINGS,
  SALON_HOME,
  MY_BOOKINGS_SALON,
  REFERAL,
  SALON_DETAILS_ROUTE,
} from "../../../constants";
import { parseJwt } from "../../../utils";
import WalletWhite from "../../../assets/wallet_white.svg";
import Back from "../../../assets/icon_back_white.svg";
import { REFERAL_AMOUNT } from "../../../constants";
import "./Footer.scss";

const Footer = ({
  history,
  children,
  className,
  showInvite,
  showBookForCustomer,
}) => {
  const salonDetails = parseJwt();
  const { salon_id } = salonDetails;
  const {
    location: { pathname },
  } = history;

  const [showAddBillOption, toggleAddBillOption] = useState(false);

  const [userDetails, updateUserDetails] = useState({
    on_behalf_of_mobile_no: "",
    on_behalf_of_username: "",
  });

  const navigationObject = returnNavigationObject();

  const homeSelected =
    pathname === "/user-home" ||
    pathname === `${SALON_HOME}` ||
    pathname === "/";

  const myBookingsSelected =
    pathname === `${MY_BOOKINGS}` || pathname === `${MY_BOOKINGS_SALON}`;

  const updatePayLoad = ({ key, value }) => {
    updateUserDetails({
      ...userDetails,
      [key]: value,
    });
  };

  const setDataForOwnCustomer = () => {
    window.location.href = `${SALON_DETAILS_ROUTE}/${salon_id}`;
    sessionStorage.setItem(
      "on_behalf_of_mobile_no",
      userDetails.on_behalf_of_mobile_no.trim()
    );
    sessionStorage.setItem(
      "on_behalf_of_username",
      userDetails.on_behalf_of_username.trim()
    );
  };

  return (
    <footer className={"app-footer " + className}>
      {showInvite && (
        <div className="invite-footer" onClick={() => history.push(REFERAL)}>
          <img src={WalletWhite} alt={WalletWhite} className="walet-image" />
          {`Invite a friend and get Rs ${REFERAL_AMOUNT} off`}
          <img className="refer-carot" src={Back} />
        </div>
      )}
      {showBookForCustomer && (
        <div onClick={() => toggleAddBillOption(!showAddBillOption)}>
          <div className="plus-add-bill-icon">
            {showAddBillOption ? `-` : `+`}
          </div>
        </div>
      )}
      <div
        className={
          showAddBillOption
            ? "book-for-salon-container salon-container-shown"
            : "book-for-salon-container salon-container-hidden"
        }
      >
        <div className="bill-label">Generate Bill</div>
        <div className="book-for-salon">
          <TextBox
            specification={
              <img
                style={{ width: "20px", height: "20px" }}
                alt={Account}
                src={Account}
              />
            }
            placeholder={"Enter Customer Name"}
            value={userDetails.on_behalf_of_username}
            onChange={(event) => {
              updatePayLoad({
                key: "on_behalf_of_username",
                value: event.target.value,
              });
            }}
            className="book-my-appointment"
          />
          <TextBox
            placeholder={"Enter Customer Number"}
            specification={<span style={{ fontSize: "15px" }}>📞</span>}
            value={userDetails.on_behalf_of_mobile_no.trim()}
            type="number"
            onChange={(event) => {
              updatePayLoad({
                key: "on_behalf_of_mobile_no",
                value: event.target.value,
              });
            }}
            className="book-my-appointment"
          />
          <Button
            text="Generate Bill"
            className="book-my-appintment-button"
            onClick={setDataForOwnCustomer}
            disabled={
              !userDetails.on_behalf_of_username.trim().length ||
              !userDetails.on_behalf_of_mobile_no.length
            }
          />
        </div>
      </div>
      <div className="navigation-footer">
        {children ? (
          children
        ) : (
          <Fragment>
            <div
              className={homeSelected && "selected-navigation"}
              onClick={() => (window.location.href = navigationObject.home)}
            >
              <img alt={Home} src={homeSelected ? HomeSelected : Home} />
              <div>Home</div>
            </div>
            <div
              className={myBookingsSelected && "selected-navigation"}
              onClick={() =>
                (window.location.href = navigationObject.myBookings)
              }
            >
              <img
                alt={MyBookings}
                src={myBookingsSelected ? MyBookingsSelected : MyBookings}
              />
              <div>My Bookings</div>
            </div>
            <div
              onClick={() => (window.location.href = navigationObject.sideMenu)}
              className={
                pathname === "/my-account" ||
                (pathname === "/sidemenu" && "selected-navigation")
              }
            >
              <img alt={Account} src={Account} />
              <div>Account</div>
            </div>
          </Fragment>
        )}
      </div>
    </footer>
  );
};

Footer.propTypes = {
  history: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};
export default withRouter(Footer);
